const pauseYTVideos = () => {
  const ytVideos = document.getElementsByClassName('youtube-video');
  Array.from(ytVideos).map(video =>
    video?.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'),
  );
  if (window.fanYTPlayers) {
    window.fanYTPlayers.forEach((player) => {
      if (player) {
        try {
          player.pauseVideo();
        } catch (error) { return error; }
      }
      return true;
    });
  }
};

export default pauseYTVideos;
